import { render, staticRenderFns } from "./BaseDetailDrawer.vue?vue&type=template&id=694dfb2d"
import script from "./BaseDetailDrawer.vue?vue&type=script&lang=js"
export * from "./BaseDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./BaseDetailDrawer.vue?vue&type=style&index=0&id=694dfb2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports